// Layout Types
import UserProfile from "../customer/userProfile/UserProfile";
import Categorydetail from "../customer/userProfile/categoryDetail/Categorydetail";
import UserLayout from "../layout/UserLayout";
import Availabilty from "../customer/availabilty/Availabilty";
import CheckOut from "../customer/checkOut/CheckOut";
import BookingInfo from "../customer/bookingInfo/BookingInfo";
import BookingInfoMoving from "../customer/bookingInfo/BookingInfoMoving";
import JobDetailsServices from "../customer/jobDetail/JobDetailsServices";
import JobRequest from "../customer/jobHistory/JobRequest";
import JobDetailUser from "../customer/jobDetail/JobDetailUser";
import JobHistoryUser from "../customer/jobHistory/JobHistoryUser";
import JobStatus from "../customer/deliveryStatus/JobStatus";
import ViewProfileDetails from "../customer/viewProfileDetails/ViewProfileDetails";
import JobDetails from "../customer/jobDetail/JobDetails";
import Livelocation from "../customer/liveLocation/Livelocation";
import TransactionHistory from "../components/managePayment/TransactionHistory";
import Chat from "../components/userChat/Userchat"
import NotificationList from "../components/notification/NotificationList";
import Viewrating from "../customer/viewRating/Viewrating"
import MarketingJob from "../customer/marketingJob/MarketingJob";

// Route Views

const userRoutes = [
  {
    path: "/consumer/profile",
    exact: true,
    layout: UserLayout,
    component: <UserProfile />,
  },
  {
    path: "/consumer/detailPage",
    exact: true,
    layout: UserLayout,
    component: <Categorydetail />,
  },
 {
    path: '/consumer/availabilty',
    exact: true,
    layout: UserLayout,
    component: <Availabilty />
  },
  {
    path: '/consumer/job/checkout',
    exact: true,
    layout: UserLayout,
    component: <CheckOut />
  },
  {
    path: '/consumer/job/booking-info',
    exact: true,
    layout: UserLayout,
    component: <BookingInfo />
  },
  {
    path: '/consumer/job/booking-info/moving',
    exact: true,
    layout: UserLayout,
    component: <BookingInfoMoving />
  },
  {
    path: '/consumer/jobs',
    exact: true,
    layout: UserLayout,
    component: <JobHistoryUser />
  },
  {
    path: '/consumer/jobdetail',
    exact: true,
    layout: UserLayout,
    component: <JobDetailUser />
  },
  {
    path: '/consumer/jobrequest',
    exact: true,
    layout: UserLayout,
    component: <JobRequest />
  },
  {
    path: '/job/detail',
    exact: true,
    layout: UserLayout,
    component: <JobDetailsServices />
  },
  {
    path: '/job/status',
    exact: true,
    layout: UserLayout,
    component: <JobStatus />
  },
  {
    path: '/job/profile',
    exact: true,
    layout: UserLayout,
    component: <ViewProfileDetails />
  },
  {
    path: '/consumer/job/detail',
    exact: true,
    layout: UserLayout,
    component: <JobDetails />
  },
  {
    path: '/consumer/job/trucking',
    exact: true,
    layout: UserLayout,
    component: <Livelocation />
  },
  {
    path: '/transaction-history',
    exact: true,
    layout: UserLayout,
    component: <TransactionHistory />
  },
  {
    path: '/chat',
    exact: true,
    layout: UserLayout,
    component: <Chat />
  },
  {
    path: '/notification-list',
    exact: true,
    layout: UserLayout,
    component: <NotificationList />
  },

  {
    path: '/consumer/viewrating',
    exact: true,
    layout: UserLayout,
    component: <Viewrating />
  },

  {
    path: '/consumer/marketingjob',
    exact: true,
    layout: UserLayout,
    component: <MarketingJob />
  },
];

export default userRoutes;
